import { FirebaseAuthentication } from 'services/firebase';

const reauthenticate = async (email, password) => {
  if (!email) throw new Error('email cannot be empty');
  if (!password) throw new Error('password cannot be empty');

  const auth = FirebaseAuthentication();

  await auth.signOut();
  const userCredential = await auth.signInWithEmailAndPassword(email, password);
  const { user } = userCredential;

  return user.emailVerified;
};

export default reauthenticate;
